import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./MainPageStyle.css"
import Popup from "./CondPopUp";
import { Units } from '../model/UnitsModel';

interface Props {
  tag: string;
  name: string;
  loggedState: number;
  loggedID: string;
  setloggedState: React.Dispatch<React.SetStateAction<number>>;
  testAlarms: number;
  agbStatus: number;
  dsgvoStatus: number;
  useCondStatus: number;
  alarmMonitorURL: string;
}

function MainPage({ tag, name, loggedState, loggedID, setloggedState, testAlarms, agbStatus, dsgvoStatus, useCondStatus, alarmMonitorURL }: Props) {

  const [keyword, setKeyword] = useState("")
  const [street, setStreet] = useState("")
  const [streetNum, setStreetNum] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const [place, setPlace] = useState("")
  const [selection, setSelection] = useState('Adresse');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [address, setAddress] = useState('');
  const [showPopUp, setShowPopup] = useState(false);
  const [useAlarmMonitor, setUseAlarmMonitor] = useState(false);
  const [units, setUnits] = useState<Units[]>([]);
  const [selectedUnits, setSelectedUnits] = useState<{ ID: number; Unit: string; checked: boolean }[]>([]);

  useEffect(() => {
    // Überprüfen, ob einer der Status ungleich 1 ist
    if (agbStatus !== 1 || dsgvoStatus !== 1 || useCondStatus !== 1) {
      setShowPopup(true);
    }
    ReadUnits(loggedID);
  }, [agbStatus, dsgvoStatus, useCondStatus]);

  const ReadUnits = async (loginID: String) => {
    try {
      //console.log('loggedID:', loginID);
      const transferCheckSum = 'xz5h4z3o';
      const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/ReadUnits.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          transferCheckSum,
          loginID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        //console.log('Cars vorhanden:', data);
        setUnits(data);
        setSelectedUnits(
          (data as Units[]).map(e => ({
            ID: e.ID,
            Unit: e.Unit,
            checked: false,
          }))
        );
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen der Units:', response.statusText);
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }
  };

  const getCoordinatesFromAddress = async () => {

    if (!street || !streetNum || !postalCode || !place) {
      alert("Bitte geben Sie Straße, Hausnummer, PLZ und Ort ein.");
      return;
    }

    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(street + ', ' + postalCode + ', ' + place)}`);

      const data = await response.json();

      if (data && data.length > 0) {
        const { lat, lon } = data[0]; // Nimm die erste Adresse aus den Ergebnissen
        const newLat = parseFloat(lat) + 0.0000442;
        const newLon = parseFloat(lon) + 0.0001073;
        setLatitude(newLat.toString());
        setLongitude(newLon.toString());
        createPushNot(keyword, street, streetNum, postalCode, place, tag, lon, lat);
        if (useAlarmMonitor) {
          if (alarmMonitorURL != "") {
            const address = street + " " + streetNum + " " + postalCode + " " + place;
            triggerAlarmMonitor(alarmMonitorURL, keyword, lon, lat, keyword, address);
          }
          else {
            console.error("Keine Alarmmonitor URL gesetzt");
          }

        }
      } else {
        alert("Keine Koordinaten für diese Adresse gefunden.");
      }
    } catch (error) {
      console.error("Fehler beim Abrufen der Koordinaten:", error);
      alert("Es gab einen Fehler beim Abrufen der Koordinaten.");
    }
  };

  const getCoordinatesAddress = async () => {
    if (!longitude || !latitude) {
      alert("Bitte geben Sie sowohl den Längengrad als auch den Breitengrad ein.");
      return;
    }

    try {
      const manLatitude = (parseFloat(latitude.replace(",", ".")) + 0.0000442).toFixed(7)
      const manLongitude = (parseFloat(longitude.replace(",", ".")) + 0.0001073).toFixed(7)

      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${manLatitude}&lon=${manLongitude}&addressdetails=1`
      );
      const data = await response.json();
      //console.log(data)
      if (data && data.address) {
        // Die gewünschten Informationen extrahieren
        const streetNumber = data.address.house_number || ''
        setStreet(data.address.road + " " + streetNumber || '');
        setPostalCode(data.address.postcode || '');
        setPlace(data.address.village || '');
        setAddress(data.address)
        createPushNot(keyword, data.address.road, streetNumber, data.address.postcode, data.address.village, tag, manLongitude, manLatitude);
        if (useAlarmMonitor) {
          if (alarmMonitorURL != "") {
            const address = street + " " + streetNum + " " + postalCode + " " + place;
            triggerAlarmMonitor(alarmMonitorURL, keyword, parseFloat(manLongitude), parseFloat(manLatitude), keyword, address);
          }
          else {
            console.error("Keine Alarmmonitor URL gesetzt");
          }

        }
      } else {
        alert("Keine Adresse für diese Koordinaten gefunden.");
      }
    } catch (error) {
      console.error("Fehler beim Abrufen der Adresse:", error);
      alert("Es gab einen Fehler beim Abrufen der Adresse.");
    }
  };



  const navigate = useNavigate();

  useEffect(() => {
    if (loggedState === 0) {
      navigate("/"); // Leitet zur gewünschten Seite weiter, wenn tag nicht gesetzt ist
    }
  }, [tag, navigate]);


  const onButtonClick = async () => {
    if (selectedUnits.length === 0) {
      tag = tag;
    } else {

    }

    if (selection === "Adresse") {
      //console.log("kadress")
      await getCoordinatesFromAddress()
    } else {
      //console.log("koord")
      await getCoordinatesAddress()
    }
    //handleLogin(keyword, street, postalCode, place, tag, longitude,latitude);
    setloggedState(0);
  }



  const createPushNot = async (keyword: string, street: string, streetNum: string, postalCode: string, place: string, tag: string, longitude: string, latitude: string) => {
    //console.log("keyword: " ,keyword)
    //console.log("street: " ,street)
    //console.log("postalCode: " ,postalCode)
    //console.log("place: " ,place)
    //console.log("tag: " ,tag)

    try {
      const teAlarm = testAlarms - 1
      handleTestAlarms(teAlarm, tag)
      sendPushOneSignal(keyword, street, streetNum, postalCode, place, tag, longitude, latitude)

      const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/SendPushNotification.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          keyword,
          street,
          streetNum,
          postalCode,
          place,
          tag,
          longitude,
          latitude,
        }),
      });



      if (response.ok) {
        //const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        console.log('Erfolgreich gesendet');
        navigate("/")
      } else {
        //const data = await response.json();
        //console.log(data);
        console.error('Fehler Response:', response.statusText);
      }
    } catch (error) {
      console.error('Fehler beim senden:', error);
    }
  };

  const sendPushOneSignal = async (keyword: string, street: string, streetNum: string, postalCode: string, place: string, tag: string, longitude: string, latitude: string) => {
    //console.log("keyword: " ,keyword)
    //console.log("street: " ,street)
    //console.log("postalCode: " ,postalCode)
    //console.log("place: " ,place)
    //console.log("tag: " ,tag)
    //console.log("longitude: " ,longitude)
    //console.log("latitude: " ,latitude)
    try {

      const unitsToSend = selectedUnits
        .filter(u => u.checked)  // nur ausgewählte
        .map(u => ({ Unit: u.Unit })); // nur Unit-Feld

      console.log('UnitsToSent',unitsToSend);

      const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/SendPushNotificationOneSignal.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          keyword,
          street,
          streetNum,
          postalCode,
          place,
          tag,
          longitude,
          latitude,
          unitsToSend,
        }),
      });

      if (response.ok) {
        //const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        //console.log('Erfolgreich gesendet');
        navigate("/")
      } else {
        //const data = await response.json();
        //console.log(data);
        console.error('Fehler Response:', response.statusText);
      }
    } catch (error) {
      console.error('Fehler beim senden:', error);
    }
  };

  const handleTestAlarms = async (testAlarms: number, tag: String) => {
    if (testAlarms >= 0) {
      try {
        const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/UpdateTestAlarms.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            tag,
            testAlarms,
          }),
        });

        if (response.ok) {
          //const data = await response.json();
          // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
          //console.log('Erfolgreich gesendet');
          navigate("/")
        } else {
          //const data = await response.json();
          //console.log(data);
          console.error('Fehler Response:', response.statusText);
        }
      } catch (error) {
        console.error('Fehler beim senden:', error);
      }
    }
  };

  const triggerAlarmMonitor = async (baseUrl: string, alarmText: string, longitude: number, latitude: number, keyword: string, address: string): Promise<void> => {
    try {
      const url = new URL(baseUrl);
      url.searchParams.append("Alarmtext", "Übung " + alarmText);
      url.searchParams.append("Longitude", longitude.toString());
      url.searchParams.append("Latitude", latitude.toString());
      url.searchParams.append("Keyword", "Übung " + keyword);
      url.searchParams.append("Address", address);
      //console.error(url);

      const response = await fetch(url.toString(), {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`);
      }

      console.log("Alarm triggered successfully");
    } catch (error) {
      console.error("Error triggering alarm:", error);
    }
  };

  return <div className="mainContainer">
    {showPopUp && (
      <Popup
        tag={tag}
        agbStatus={agbStatus}
        dsgvoStatus={dsgvoStatus}
        useCondStatus={useCondStatus}
      />
    )}

    <button className="settings-button" onClick={() => navigate("/Settings")}>Einstellungen</button>

    <h2>Neuer Einsatz für {name}:</h2>

    <div className="formGrid">
      {/* Linke Spalte */}
      <div className="leftColumn">
        <div className="inputContainer">
          <label>Stichwort eingeben:</label>
          <input
            value={keyword}
            placeholder="Stichwort eingeben"
            onChange={ev => setKeyword(ev.target.value)}
            className="inputBox"
          />
        </div>

        {units.length > 0 && (
          <div className="inputContainer">
            <label>Einheiten auswählen:</label>
            <table className="MainPage_table">
              <thead>
                <tr className="MainPage_table-header">
                  <th className="MainPage_col-1">Auswahl</th>
                  <th className="MainPage_col-2">Einheit</th>
                </tr>
              </thead>
              <tbody>
                {selectedUnits.map(einheit => (
                  <tr className="MainPage_table-row" key={einheit.ID}>
                    <td className="MainPage_col-1">
                      <input
                        type="checkbox"
                        checked={einheit.checked}
                        onChange={() =>
                          setSelectedUnits(prev =>
                            prev.map(e =>
                              e.ID === einheit.ID
                                ? { ...e, checked: !e.checked }
                                : e
                            )
                          )
                        }
                      />
                    </td>
                    <td className="MainPage_col-2">{einheit.Unit}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Rechte Spalte */}
      <div className="rightColumn">
        <div className="inputContainer">
          <label>Typ auswählen:</label>
          <select value={selection} onChange={e => setSelection(e.target.value)} className="inputBox">
            <option value="Adresse">Adresse</option>
            <option value="Koordinate">Koordinate</option>
          </select>
        </div>

        {selection === 'Adresse' && (
          <>
            <div className="inputContainer">
              <label>Straße eingeben:</label>
              <input
                value={street}
                placeholder="Straße eingeben"
                onChange={ev => setStreet(ev.target.value)}
                className="inputBox"
              />
            </div>
            <div className="inputContainer">
              <label>Hausnummer eingeben:</label>
              <input
                value={streetNum}
                placeholder="Hausnummer eingeben"
                onChange={ev => setStreetNum(ev.target.value)}
                className="inputBox"
              />
            </div>
            <div className="inputContainer">
              <label>PLZ eingeben:</label>
              <input
                value={postalCode}
                placeholder="PLZ eingeben"
                onChange={ev => setPostalCode(ev.target.value)}
                className="inputBox"
              />
            </div>
            <div className="inputContainer">
              <label>Ort eingeben:</label>
              <input
                value={place}
                placeholder="Ort eingeben"
                onChange={ev => setPlace(ev.target.value)}
                className="inputBox"
              />
            </div>
          </>
        )}

        {selection === 'Koordinate' && (
          <>
            <div className="inputContainer">
              <label>Längengrad eingeben:</label>
              <input
                value={longitude}
                placeholder="Längengrad eingeben"
                onChange={ev => setLongitude(ev.target.value)}
                className="inputBox"
              />
            </div>
            <div className="inputContainer">
              <label>Breitengrad eingeben:</label>
              <input
                value={latitude}
                placeholder="Breitengrad eingeben"
                onChange={ev => setLatitude(ev.target.value)}
                className="inputBox"
              />
            </div>
          </>
        )}
      </div>
    </div>

    <div className="betaBox">
      <p>
        <strong>Beta-Funktion:</strong> Durch Aktivieren wird neben der
        Alarmierung auf den Smartphones ein hinterlegter GroupAlarm
        Alarmmonitor aktiviert. Haben Sie Interesse an dieser Beta-Funktion,
        wenden Sie sich bitte an <a href="mailto:info@mbsoftwaresolutions.de">info@mbsoftwaresolutions.de</a>.
      </p>
      <label className="checkboxLabel">
        <input
          type="checkbox"
          checked={useAlarmMonitor}
          onChange={() => setUseAlarmMonitor(!useAlarmMonitor)}
        />
        &nbsp;Alarmmonitor aktivieren
      </label>
    </div>

    <div className="inputContainer">
      <input
        className="inputButton"
        type="button"
        onClick={onButtonClick}
        value={"Senden"}
      />
    </div>
  </div>
};

export default MainPage;